import gql from 'graphql-tag';

export const ArticleCardFragment = gql`
  fragment ArticleCardFragment on ArticleCollection {
    items {
      sys {
        id
      }
      title
      subtitle
      readTimeComputed
      readTimeHandcoded
      shortDescription
      editorialLastPublishedDateComputed
      editorialOriginalPublishDate
      body {
        json
      }
      slug
      primaryImage {
        describedImage
        longDescribedImage
        maxWidth
        image {
          title
          url
        }
      }
      # An article could have 2 categories. One parent and one child
      categoriesCollection(limit: 2) {
        items {
          title
          parentCategory {
            title
          }
          linkedFrom {
            categoryAssemblyCollection(limit: 1) {
              items {
                slug
                internalName
                category {
                  title
                }
              }
            }
          }
        }
      }
      authorsCollection(limit: 1) {
        items {
          displayName
          email
          primaryImage {
            describedImage
            longDescribedImage
            maxWidth
            image {
              title
              url
              width
              height
            }
          }
          biographyShort
        }
      }
    }
  }
`;
